import React from "react";
import { Link } from "react-router-dom";
import { ArgovLogo } from "./ArgovLogo";
import { ARGOVAcronym } from "./ARGOVAcronym";

const monoLabel = { fontSize: 10, letterSpacing: "0.14em", color: "#4a6080", textTransform: "uppercase", marginBottom: 14 };
const linkStyle = { color: "#8fa3c8" };
const ul = { listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 8, fontSize: 13.5 };

export const Footer = () => (
  <footer className="argov-footer" style={{ background: "#080f1e", padding: "56px 48px 24px", color: "#5e80a0" }}>
    <div style={{ maxWidth: 1280, margin: "0 auto" }}>
      <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 1fr 1fr 1fr", gap: 40, marginBottom: 40 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
            <ArgovLogo />
            <span style={{ fontSize: 17, fontWeight: 800, color: "#ffffff", letterSpacing: "-0.02em" }}>
              ARGOV<span style={{ color: "#0891b2", fontWeight: 500 }}>™</span>
            </span>
          </div>
          <p style={{ fontSize: 13.5, color: "#8fa3c8", lineHeight: 1.7, maxWidth: 340 }}>
            <ARGOVAcronym color="#4db8ff" base="#8fa3c8" weight={800} />. AI governance enforced at runtime — for ARGOV Intelligence Enterprise Platform.
          </p>
        </div>

        <div>
          <p className="font-mono" style={monoLabel}>PLATFORM</p>
          <ul style={ul}>
            <li><Link to="/" style={linkStyle}>Platform</Link></li>
            <li><a href="/#solutions" style={linkStyle}>Solutions</a></li>
            <li><Link to="/frameworks" style={linkStyle}>Frameworks</Link></li>
            <li><Link to="/compliance" style={linkStyle}>Compliance</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-mono" style={monoLabel}>COMPANY</p>
          <ul style={ul}>
            <li><Link to="/team" style={linkStyle}>Team</Link></li>
            <li><Link to="/enterprise" style={linkStyle}>Enterprise</Link></li>
            <li><Link to="/trust" style={linkStyle}>Trust Center</Link></li>
            <li><Link to="/contact" style={linkStyle}>Contact</Link></li>
          </ul>
        </div>

        <div>
          <p className="font-mono" style={monoLabel}>LEGAL</p>
          <ul style={ul}>
            <li><Link to="/terms" style={linkStyle}>Terms of Service</Link></li>
            <li><Link to="/privacy" style={linkStyle}>Privacy Policy</Link></li>
            <li><Link to="/legal" style={linkStyle}>Legal Notice</Link></li>
            <li><Link to="/cookies" style={linkStyle}>Cookie Policy</Link></li>
            <li><a href="mailto:security@argov.ai" style={linkStyle}>Security &amp; Disclosure</a></li>
          </ul>
        </div>

        <div>
          <p className="font-mono" style={monoLabel}>ALIGNED TO</p>
          <ul style={{ ...ul, color: "#8fa3c8" }}>
            <li>NIST AI RMF 1.0</li>
            <li>ISO/IEC 42001:2023</li>
            <li>UAE AI Strategy 2031</li>
            <li>UAE NESA IA Standards</li>
          </ul>
        </div>
      </div>

      {/* Legal micro-block */}
      <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 10, padding: "16px 20px", marginBottom: 22 }}>
        <p style={{ fontSize: 11.5, color: "#5e80a0", lineHeight: 1.7 }}>
          <strong style={{ color: "#8fa3c8" }}>Legal notice.</strong> ARGOV™, <ARGOVAcronym color="#4db8ff" base="#5e80a0" weight={600} />, and all product marks are trademarks of ARGOV. Third-party marks (NIST, ISO, IEEE, UAE PDPL, NESA, CBUAE, DOH, DHA, TRA, EU AI Act, Microsoft, Salesforce, ServiceNow and others) are the property of their respective owners; references are descriptive and do not imply affiliation or endorsement. Statements regarding regulatory alignment describe design objectives, not certification. Content on this site is informational and does not constitute legal, compliance, or professional advice. Screenshots, session traces, statistics, and scenario walk-throughs are illustrative examples. Forward-looking statements are subject to risk and uncertainty; ARGOV disclaims any obligation to update them. See our <Link to="/terms" style={{ color: "#4db8ff" }}>Terms</Link>, <Link to="/privacy" style={{ color: "#4db8ff" }}>Privacy Policy</Link>, and <Link to="/legal" style={{ color: "#4db8ff" }}>Legal Notice</Link>.
        </p>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.08)", paddingTop: 22, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 16 }}>
        <p className="font-mono" style={{ fontSize: 11, color: "#4a6080", letterSpacing: "0.06em" }}>
          © {new Date().getFullYear()} ARGOV™ · ARGOV Intelligence Enterprise Platform
        </p>
        <p className="font-mono" style={{ fontSize: 11, color: "#4a6080", letterSpacing: "0.06em" }}>
          POLICY_ENGINE // ACTIVE
        </p>
      </div>
    </div>
  </footer>
);
